import { useTranslation } from "react-i18next";
import LocalizedLink from "./LocalizedLink";
import { Logo } from "./Nav";

export const CONTACT_EMAIL = "hello@stigelife.com";

const MARKETS = [["vietnam", "vietnam"], ["indonesia", "indonesia"], ["malaysia", "malaysia"], ["uae", "uae"], ["saudi-arabia", "saudiArabia"], ["kenya", "kenya"], ["nigeria", "nigeria"]];
const LINKS = [["products", "/products"], ["how", "/how-we-work"], ["quality", "/quality"], ["about", "/about"], ["contact", "/contact"]];

const Heading = ({ children }) => <p className="font-mono text-xs font-medium tracking-[0.18em] uppercase text-ice/80 mb-6">{children}</p>;
const linkCls = "text-white/85 hover:text-white transition-colors duration-300";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer data-testid="site-footer" className="on-navy bg-ink text-white">
      <div className="max-w-[1240px] mx-auto px-6 md:px-12 xl:px-16 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-white/10">
          <div className="md:col-span-4">
            <Logo dark />
            <p className="mt-8 font-mono text-xs tracking-[0.18em] uppercase text-ice" data-testid="footer-descriptor">
              {t("footer.positioning")}
            </p>
          </div>
          <div className="md:col-span-2">
            <Heading>{t("footer.company")}</Heading>
            <ul className="space-y-3 text-sm">
              {LINKS.map(([key, to]) => (
                <li key={to}>
                  <LocalizedLink to={to} data-testid={`footer-link-${key}`} className={linkCls}>{t(`nav.${key}`)}</LocalizedLink>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <Heading>{t("footer.markets")}</Heading>
            <ul className="space-y-3 text-sm">
              {MARKETS.map(([slug, key]) => (
                <li key={slug}>
                  <LocalizedLink to={`/markets/${slug}`} data-testid={`footer-link-market-${slug}`} className={linkCls}>{t(`footer.${key}`)}</LocalizedLink>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <Heading>{t("footer.contact")}</Heading>
            <div className="border-b border-white/10 pb-4">
              <p className="font-mono text-xs tracking-[0.18em] uppercase text-ice/80">{t("footer.contactLabels.email")}</p>
              <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email" className="inline-block mt-2 text-sm text-white hover:text-ice transition-colors" dir="ltr">
                {CONTACT_EMAIL}
              </a>
            </div>
            <ul className="space-y-3 text-sm mt-8">
              <li><LocalizedLink to="/privacy" data-testid="footer-link-privacy-policy" className={linkCls}>{t("footer.privacy")}</LocalizedLink></li>
              <li><LocalizedLink to="/terms" data-testid="footer-link-terms-conditions" className={linkCls}>{t("footer.terms")}</LocalizedLink></li>
            </ul>
            <p className="mt-8 text-xs text-ice/80 leading-relaxed max-w-sm">{t("footer.disclaimer")}</p>
          </div>
        </div>
        <div className="pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-xs text-ice/80" data-testid="footer-copyright">{t("footer.copyright", { year: new Date().getFullYear() })}</p>
          <p className="font-mono text-xs tracking-[0.16em] uppercase text-ice/80" data-testid="footer-promise">{t("footer.motto")}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
